<template>
  <div class="content container-fluid">
    <!-- Popover for Filter -->
    <popover
      name="popName"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranName"
        :options="colFilter.tran_name_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popCode"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranCode"
        :options="colFilter.tran_code_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popStatus"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranStatus"
        :options="colFilter.tran_status_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <!-- /Popover for Filter -->

    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Merchants</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="add">
            <i class="fa fa-plus"></i>Add Merchant
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Pagination -->
    <div class="row">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">No</th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popName
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranName.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('name')">
                    Merchant Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'name'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'name_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th style="width: 25%">
                  <i
                    class="fa fa-filter"
                    v-popover:popCode
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranCode.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('code')">
                    Code
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'code'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'code_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>Login URL / API Key</th>
                <th class="status-col">
                  <i
                    class="fa fa-filter"
                    v-popover:popStatus
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranStatus.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('status')">
                    Status
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'status'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'status_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(merchant, i) in merchants" :key="i">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td>{{ merchant.name }}</td>
                <td>{{ merchant.code }}</td>
                <td>
                  Login URL: <a :href="merchant.loginURL" target="_blank">{{ merchant.loginURL }}</a>
                  <br />
                  API Key: {{ merchant.api_key }}
                </td>
                <td>
                  <span
                    class="badge badge-pill"
                    :class="{
                      'badge-success': merchant.status == statusActive,
                      'badge-danger': merchant.status == statusInactive,
                    }"
                  >
                    {{ merchant.status }}
                  </span>
                </td>
                <td class="action-col">
                  <label class="toggler">
                    <input
                      type="checkbox"
                      :checked="merchant.status == statusActive"
                      @change="toggle(merchant.id, $event)"
                    />
                    <span class="slider round"></span>
                  </label>
                  <button
                    class="btn btn-sm btn-primary mt-1"
                    @click="edit(merchant)"
                  >
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </button>
                  <button
                    class="btn btn-sm btn-danger mt-1"
                    @click="remove(merchant.id)"
                  >
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </button>
                </td>
              </tr>
              <tr v-if="merchants && !merchants.length">
                <td colspan="6" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="merchants && merchants.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          merchants.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- Add/Update Merchant Modal -->
    <div class="modal custom-modal fade" id="merchantModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">
              {{ merchant.id ? "Edit" : "Add" }} Merchant
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <form @submit.prevent="save">
              <div class="form-group">
                <label>Allow Flexible E-coupon</label>
                <input
                  type="checkbox"
                  v-model="merchant.allow_flexible_ecoupon"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label>Allow Batch E-coupon</label>
                <input
                  type="checkbox"
                  v-model="merchant.allow_batch_ecoupon"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label>Merchant Name</label>
                <input
                  type="text"
                  placeholder="Merchant Name"
                  v-model="merchant.name"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>Code</label>
                <input
                  type="text"
                  placeholder="Merchant Code used for login and e-voucher"
                  v-model="merchant.code"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>Addon Date Label</label>
                <input
                  type="text"
                  placeholder="Addon Date"
                  v-model="merchant.addon_date_label"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label>Cancellation Email Recipient(s)</label>
                <input
                  type="text"
                  placeholder="Comma separated for multiple emails"
                  v-model="merchant.cancellation_email_recipients"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label>Cancellation BCC Email Recipient(s)</label>
                <input
                  type="text"
                  placeholder="Comma separated for multiple emails"
                  v-model="merchant.cancellation_bcc_email_recipients"
                  class="form-control"
                />
              </div>
              <div class="submit-section mt-4">
                <button class="btn btn-primary submit-btn">
                  {{ merchant.id ? "Update" : "Add" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Add Merchant Modal -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Multiselect from "vue-multiselect";
import $ from "jquery";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      statusActive: config.STATUS_ACTIVE,
      statusInactive: config.STATUS_INACTIVE,
      merchants: [],
      //popup
      merchant: { id: "", name: "", code: "", addon_date_label: "", cancellation_email_recipients: "", cancellation_bcc_email_recipients: "" },
      //pagination
      searchColFilter: {
        tranName: [],
        tranCode: [],
        tranStatus: [],
      },
      colFilter: {},
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
      currentHost: window.location.host
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data.token;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.token}` } };
    },
    searchFilter() {
      return [
        { name: "tranName", val: this.searchColFilter.tranName },
        { name: "tranCode", val: this.searchColFilter.tranCode },
        { name: "tranStatus", val: this.searchColFilter.tranStatus },
      ];
    },
  },
  watch: {
    "searchColFilter.tranName": function (val, oldVal) {
      this.getMerchantList();
    },
    "searchColFilter.tranCode": function (val, oldVal) {
      this.getMerchantList();
    },
    "searchColFilter.tranStatus": function (val, oldVal) {
      this.getMerchantList();
    },
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getMerchantList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    add() {
      this.merchant = { id: "", name: "", code: "" };
      $("#merchantModal").modal("show");
    },
    edit(payload) {
      this.merchant.id = payload.id;
      this.merchant.name = payload.name;
      this.merchant.code = payload.code;
      this.merchant.allow_batch_ecoupon = payload.allow_batch_ecoupon;
      this.merchant.allow_flexible_ecoupon = payload.allow_flexible_ecoupon;
      this.merchant.addon_date_label = payload.addon_date_label;
      this.merchant.cancellation_email_recipients = payload.cancellation_email_recipients;
      this.merchant.cancellation_bcc_email_recipients = payload.cancellation_bcc_email_recipients;
      $("#merchantModal").modal("show");
    },
    getMerchantList() {
      let param = {
        current_page: this.paging.CurrentPage,
        total_page: this.paging.TotalPage,
        size_per_page: this.paging.SizePerPage,
        sort_by: this.paging.SortBy,
        search_filter: this.searchFilter,
      };
      this.$store.state.isLoading = true;
      API.getMerchants(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.merchants = response.data.records;
            for ( var index in this.merchants ) {
              let merchant = this.merchants[index];
              this.merchants[index].loginURL = (process.env.NODE_ENV == 'development' ? "http://" : "https://") + window.location.host + "/merchant/login/" + merchant.code;
            }
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.page_count;
            this.colFilter = response.data.col_filter;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    save() {
      let param = {
        id: this.merchant.id,
        name: this.merchant.name,
        code: this.merchant.code,
        allow_batch_ecoupon: this.merchant.allow_batch_ecoupon,
        allow_flexible_ecoupon: this.merchant.allow_flexible_ecoupon,
        addon_date_label: this.merchant.addon_date_label,
        cancellation_email_recipients: this.merchant.cancellation_email_recipients,
        cancellation_bcc_email_recipients: this.merchant.cancellation_bcc_email_recipients
      };
      let action = this.merchant.id ? "update" : "add";
      let text = `Are you sure you want to ${action} the merchant?`;
      this.$swal({
        title: "Are you sure?",
        text: text,
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveMerchant(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getMerchantList();
                $("#merchantModal").modal("hide");
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    remove(id) {
      let param = { id: id };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the merchant?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteMerchant(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getMerchantList();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    toggle(id, $event) {
      let isActive = $event.target.checked;
      let param = {
        id: id,
        is_active: isActive,
      };
      this.$store.state.isLoading = true;
      API.toggleMerchant(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$swal(response.data.message, {
            icon: response.data.success ? "success" : "error",
          });
          if (response.data.success) {
            this.getMerchantList();
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getMerchantList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getMerchantList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getMerchantList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getMerchantList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getMerchantList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "code":
          if (this.paging.SortBy === "code") {
            this.paging.SortBy = "code_desc";
          } else if (this.paging.SortBy === "code_desc") {
            this.paging.SortBy = "code";
          } else {
            this.paging.SortBy = "code";
          }
          break;
        case "status":
          if (this.paging.SortBy === "status") {
            this.paging.SortBy = "status_desc";
          } else if (this.paging.SortBy === "status_desc") {
            this.paging.SortBy = "status";
          } else {
            this.paging.SortBy = "status";
          }
          break;
      }
      this.getMerchantList();
    },
  },
  created() {
    this.getMerchantList();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Admin/MerchantList.vue